import { render, staticRenderFns } from "./modalItems.vue?vue&type=template&id=03be424c&"
import script from "./modalItems.vue?vue&type=script&lang=js&"
export * from "./modalItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports